/** Godot 4.6.3's OccluderPolygon2D facts a scene's properties carry. */
/** `OccluderPolygon2D::CullMode` (`scene/2d/light_occluder_2d.h:39-43`), each member without `CULL_`. */
export const OccluderPolygon2DCullMode = {
    DISABLED: 0,
    CLOCKWISE: 1,
    COUNTER_CLOCKWISE: 2,
};
//# sourceMappingURL=lightOccluder2d.js.map